<template>
  <!-- 邮寄 -->
  <div id="mail">
    <el-card class="details_box-card" shadow="never" id="mailTop">
      <div slot="header" class="clearfix">
        <div class="descicon"></div>实验相关
      </div>
      <el-form
        ref="form"
        label-position="left"
        :model="form"
        :rules="rules"
        label-width="200px"
        style="padding-left: 15px"
      >
        <el-form-item label="是否加急" prop="ifUrgent" v-show="!isTeamShop && equipmentInfo.isSupportUrgent">
          <el-radio-group v-model="form.ifUrgent">
            <el-radio :label="1" style="width: 100px">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <div class="formTips" v-if="form.ifUrgent == 1">请务必与技术顾问确认能否加急！如确认加急，测试费用加收50%</div>
        </el-form-item>
        <hr class="dashedHr" />
        <el-form-item label="是否回收" prop="ifRecycle">
          <el-radio-group v-model="form.ifRecycle" @change="selectRecycle">
            <el-radio :label="1" style="width: 100px">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <span class="desc" v-show="form.ifRecycle == 0">样品保存7天，超过7天自动销毁</span>
        </el-form-item>
        <div v-if="form.ifRecycle == 1">
          <el-form-item label="所在省市" prop="provinceValue">
            <el-cascader
              placeholder="请选择所在省市"
              size="small"
              style="width: 560px"
              :options="regionData"
              @change="handleChange"
              v-model="form.provinceValue"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="回收详细地址" prop="recycleAddress">
            <el-input size="small" placeholder="请填写详细地址" style="width: 560px" v-model="form.recycleAddress"></el-input>
          </el-form-item>
          <el-form-item label="回收取样联系人" prop="recycleContact">
            <el-input
              size="small"
              placeholder="请填写联系人"
              style="width: 560px"
              v-model="form.recycleContact"
            ></el-input>
          </el-form-item>
          <el-form-item label="回收取样联系人电话号码" prop="recycleContactPhone">
            <el-input
              size="small"
              placeholder="请填写联系人电话号码"
              style="width: 560px"
              v-model="form.recycleContactPhone"
            ></el-input>
          </el-form-item>
        </div>
        <hr class="dashedHr" />
        <el-form-item label="实验有问题联系谁" prop="contactType">
          <el-radio-group v-model="form.contactType">
            <el-radio :label="2" style="width: 100px">其他人</el-radio>
            <el-radio :label="1">本人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="实验问题联系人" prop="contact" v-if="form.contactType == 2">
          <el-input
            size="small"
            placeholder="请填写联系人"
            style="width: 560px"
            v-model="form.contact"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人电话号码" prop="contactPhone" v-if="form.contactType == 2">
          <el-input size="small" placeholder="请填写联系人电话号码" style="width: 560px" v-model="form.contactPhone"></el-input>
        </el-form-item>
        <hr class="dashedHr" />
        <el-form-item label="是否与之前测试同设备" prop="ifTestEquipment">
          <el-radio-group v-model="form.ifTestEquipment">
            <el-radio :label="1" style="width: 100px">需要</el-radio>
            <el-radio :label="0">不需要/之前未在平台上做过测试</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选择订单" v-if="form.ifTestEquipment == 1" prop="relevanceOrderCode">
          <el-select v-model="form.relevanceOrderCode" style="width: 560px" size="small" placeholder="请选择订单">
            <el-option
              v-for="item in orderOptions"
              :key="item.orderCode"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>
    <el-tabs
      id="mailOther"
      v-model="form.postMethod"
      type="border-card"
      style="margin-top: 30px"
      @tab-click="handleClick"
    >
      <el-tab-pane label="自行邮寄" name="1">
        <h3 class="h3Title">样品寄送地址</h3>
        <el-tag
          @click="addressHandle(item,index)"
          v-for="(item,index) in unitList"
          :key="item.index"
          :effect="activeAddress == index ? 'dark' : 'light'"
          :type="activeAddress == index ? '' : 'info'"
        >{{ item.unitName }}</el-tag>
        <div class="addressInfo">
          <div class="jtaddress">{{addressInfo.deliveryAddress || '/'}}</div>
          <div class="addressOther">联系人：{{addressInfo.deliveryLeader || '/'}}</div>
          <div class="addressOther">联系电话：{{addressInfo.deliveryPhone || '/'}}</div>
        </div>
        <h3 class="h3Title">运费支付</h3>
        <el-tag
          @click="freightHandle(item)"
          v-for="(item) in payitems"
          :key="item.index"
          :effect="form.postPayment == item.index ? 'dark' : 'light'"
          :type="form.postPayment == item.index ? '' : 'info'"
        >{{ item.name }}</el-tag>
        <!-- <span class="formTips">*如您采用运费到付的方式，我们会将运费加到测试费中</span> -->
      </el-tab-pane>
      <el-tab-pane label="上门取样" name="2" v-if="$store.getters.userInfo.whiteFlag == 1 && $store.getters.userInfo.samplingFree == 1">
        <el-form
          ref="form2"
          label-position="left"
          :model="form"
          :rules="rules_2"
          label-width="200px"
          style="padding-left: 15px"
        >
          <el-form-item label="高校" prop="homeSamplingAddressId">
            <el-select size="small" v-model="form.homeSamplingAddressId" @change="changeSamplingSchool" style="width: 560px" placeholder="请选择所在高校" filterable>
              <el-option v-for="item in schoolOptions" :key="item.schoolId" :label="item.schoolName" :value="item.schoolId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="院系" prop="homeSamplingFacultyId">
            <el-select size="small" v-model="form.homeSamplingFacultyId" @change="changeSamplingFaculty" :disabled="!form.homeSamplingAddressId" style="width: 560px" placeholder="请选择所在院系">
              <el-option v-for="item in departOptions" :key="item.schoolId" :label="item.schoolName" :value="item.schoolId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="校区" prop="homeSamplingCampusId">
            <el-select size="small" v-model="form.homeSamplingCampusId" @change="changeSamplingCampus" :disabled="!form.homeSamplingAddressId" style="width: 560px" placeholder="请选择所在校区">
              <el-option v-for="item in campusOptions" :key="item.schoolId" :label="item.schoolName" :value="item.schoolId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" prop="detailedAddress">
            <el-input size="small" maxlength="50" placeholder="请填写建筑名,楼层,楼室" style="width: 560px" v-model="form.detailedAddress"></el-input>
          </el-form-item>
          <el-form-item label="上门取样联系人" prop="samplingContact">
            <el-input
              size="small"
              placeholder="请填写联系人"
              style="width: 200px;margin-right: 10px"
              maxlength="30"
              v-model="form.samplingContact"
            ></el-input>
          </el-form-item>
          <el-form-item label="取样联系人电话" prop="samplingContactPhone">
            <el-input size="small" placeholder="请填写联系人电话号码" maxlength="11" style="width: 350px" v-model="form.samplingContactPhone"></el-input>
          </el-form-item>
          <el-form-item label="上门取样时间" prop="onSiteSamplingDate">
            <el-date-picker size="small" v-model="form.onSiteSamplingDate" style="width: 560px" :picker-options="pickerOptions" type="date" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" placeholder="选择日期" ></el-date-picker>
          </el-form-item>
          <el-form-item label="选择时间段" prop="onSiteSamplingTime">
            <el-radio v-model="form.onSiteSamplingTime" label="9:00 ~ 12:00" :disabled="isSamplingTimeDisabled('9:00 ~ 12:00')">9:00 ~ 12:00</el-radio>
            <el-radio v-model="form.onSiteSamplingTime" label="14:00 ~ 18:00" :disabled="isSamplingTimeDisabled('14:00 ~ 18:00')">14:00 ~ 18:00</el-radio>
          </el-form-item>
          <el-form-item label="上门取样备注" prop="onSiteSamplingRemark">
            <el-input size="small" type="textarea"  :rows="4" placeholder="请填写上门取样备注" style="width: 560px" v-model="form.onSiteSamplingRemark" :maxlength="200" show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="自己送样" name="3">
        <h3 class="h3Title">样品寄送地址</h3>
        <el-tag
          @click="addressHandle(item,index)"
          v-for="(item,index) in unitList"
          :key="item.index"
          :effect="activeAddress == index ? 'dark' : 'light'"
          :type="activeAddress == index ? '' : 'info'"
        >{{ item.unitName }}</el-tag>
        <div class="addressInfo">
          <div class="jtaddress">{{addressInfo.deliveryAddress || '/'}}</div>
          <div class="addressOther">联系人：{{addressInfo.deliveryLeader || '/'}}</div>
          <div class="addressOther">联系电话：{{addressInfo.deliveryPhone || '/'}}</div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { regionData, codeToText } from "element-china-area-data"
import { unitList,clientOrderList , listClientWhiteList, schoolList, getUserOtherInfo } from "@/api/request"
import { isMobile } from "@/plugins/validate"
import { getClient } from "@/plugins/auth"
import dayjs from "dayjs"

export default {
  props: ['isTeamShop', 'equipmentInfo'],
  data() {
    var validateMobile = (rule, value, callback) => {
      if (value && !isMobile(value)) {
        return callback(new Error("请输入正确的电话号码"));
      }
      callback();
    };
    return {
      samplingNow: new Date(),
      samplingTimer: null,
      pickerOptions: {
        disabledDate: time => this.isSamplingDateDisabled(time)
      },
      regionData,
      activeName: "1",
      selectedOptions: [],
      schoolOptions: [],
      departOptions: [],
      campusOptions: [],
      activeAddress: 0,
      activePay: 0,
      unitList: [],
      userOtherInfo: null,
      userInfo: JSON.parse(getClient()),
      payitems: [{ name: "运费到付",index: 1 }, { name: "运费自付",index: 2 }],
      orderOptions: [],
      addressInfo: {},
      rules: {
        ifUrgent: [
          { required: true, trigger: 'change', message: '是否加急不能为空'}
        ],
        ifRecycle: [
          { required: true, trigger: 'change', message: '是否回收不能为空'}
        ],
        contactType: [
          { required: true, trigger: 'change', message: '实验有问题联系谁不能为空'}
        ],
        ifTestEquipment: [
          { required: true, trigger: 'change', message: '是否与之前测试同设备不能为空'}
        ],
        provinceValue: [
          { required: true, trigger: "change", message: "所在省市不能为空" }
        ],
        recycleAddress: [
          { required: true, trigger: "blur", message: "回收详细地址不能为空" },
          { max: 50, message: '回收地址不能超过50个字', trigger: 'blur'}
        ],
        recycleContact: [
          { required: true, trigger: "blur", message: "回收取样联系人不能为空" },
          { max: 50, message: '联系人不能超过50个字', trigger: 'blur'}
        ],
        recycleContactPhone: [
          { required: true, trigger: "blur", message: "回收取样联系人电话号码不能为空" },
          { validator: validateMobile, trigger: "blur" }
        ],
        contact: [
          { required: true, trigger: "blur", message: "联系人不能为空" },
          { max: 50, message: '联系人不能超过50个字', trigger: 'blur'}
        ],
        contactPhone: [
          { required: true, trigger: "blur", message: "联系人电话号码不能为空" },
          { validator: validateMobile, trigger: "blur" }
        ],
        onSiteSamplingDate: [
        { required: true, trigger: "change", message: "请选择上门取样时间" }
        ],
        relevanceOrderCode: [
          { required: true, trigger: "change", message: "请选择订单" }
        ],
      },
      rules_2: {
        homeSamplingAddressId: [{ required: true, trigger: "change", message: "请选择所在高校" }],
        homeSamplingFacultyId: [{ required: true, trigger: "change", message: "请选择所在院系" }],
        detailedAddress: [{ required: true, trigger: "blur", message: "请填写上门取样详细地址" }],
        samplingContact: [{ required: true, trigger: "blur", message: "请填写上门取样联系人" }],
        samplingContactPhone: [
          { required: true, trigger: "blur", message: "请填写上门取样联系人电话" },
          { validator: validateMobile, trigger: "blur" }
        ],
        onSiteSamplingDate: [
          { required: true, trigger: "change", message: "请选择上门取样时间" },
          { validator: (rule, value, callback) => {
            if(value && this.isSamplingDateDisabled(dayjs(value).toDate())) {
              return callback(new Error("该日期已不可预约，请选择其他日期"))
            }
            callback()
          }, trigger: "change" }
        ],
        onSiteSamplingTime: [
          { required: true, trigger: "change", message: "请选择取样时间段" },
          { validator: (rule, value, callback) => {
            // 提交时使用当前时间复核，避免停留页面后提交已过截止时间的预约。
            if(value && this.isSamplingTimeDisabled(value, new Date())) {
              return callback(new Error("该取样时段已不可预约，请重新选择"))
            }
            callback()
          }, trigger: "change" }
        ],
      },
      form: {
        ifUrgent: 0,
        ifRecycle: 0,
        ifTestEquipment: 0,
        contactType: 1,
        contact: "",
        contactPhone: "",
        recycleProvince: "",
        recycleAddress: "",
        recycleContact: "",
        recycleContact: "",
        postMethod: "1",
        postPayment: "1",
        addressId: "",
        homeSamplingAddress: "",
        homeSamplingAddressId: null,
        homeSamplingFaculty: "",
        homeSamplingFacultyId: null,
        homeSamplingCampus: "",
        homeSamplingCampusId: null,
        detailedAddress: "",
        samplingContact: "",
        samplingContactPhone: "",
        relevanceOrderCode: "",
        recycleContactPhone: "",
        provinceValue: [],
        provinceCode: "",
        onSiteSamplingDate: "",
        onSiteSamplingTime: '9:00 ~ 12:00',
        onSiteSamplingRemark: ""
      }
    };
  },
  watch: {
    'form.homeSamplingAddressId'(value) {
      this.loadSamplingSchoolOptions(value)
    },
    form: {
      handler() {
        this.updateSamplingSelection()
        this.$emit('getMailInfo',this.form,false)
      },
      deep: true,
    }
  },
  mounted () {
    this.getOption()
    this.getOther()
    this.refreshSamplingClock()
  },
  beforeDestroy() {
    clearTimeout(this.samplingTimer)
  },
  methods: {
    // 当天11:30起仅可预约下午，17:00起当天不可预约；过去日期始终禁选。
    isSamplingDateDisabled(date, now = new Date()) {
      const today = dayjs(now).startOf('day')
      return dayjs(date).isBefore(today, 'day') ||
        (dayjs(date).isSame(today, 'day') && now.getHours() >= 17)
    },
    isSamplingTimeDisabled(time, now = this.samplingNow) {
      const date = this.form.onSiteSamplingDate
      if(!date) return false
      if(this.isSamplingDateDisabled(dayjs(date).toDate(), now)) return true
      return dayjs(date).isSame(now, 'day') &&
        now.getHours() * 60 + now.getMinutes() >= 11 * 60 + 30 && time == '9:00 ~ 12:00'
    },
    // 日期切换、历史信息回填及跨越截止时间时，清理不可预约的选择。
    updateSamplingSelection(now = new Date()) {
      this.samplingNow = now
      const date = this.form.onSiteSamplingDate
      if(!date) return
      if(this.isSamplingDateDisabled(dayjs(date).toDate(), now)) {
        this.form.onSiteSamplingDate = ''
        this.form.onSiteSamplingTime = ''
      } else if(!this.form.onSiteSamplingTime || this.isSamplingTimeDisabled(this.form.onSiteSamplingTime, now)) {
        this.form.onSiteSamplingTime = this.isSamplingTimeDisabled('9:00 ~ 12:00', now) ? '14:00 ~ 18:00' : '9:00 ~ 12:00'
      }
    },
    refreshSamplingClock() {
      const now = new Date()
      this.updateSamplingSelection(now)
      const next = [
        dayjs(now).startOf('day').hour(11).minute(30),
        dayjs(now).startOf('day').hour(17),
        dayjs(now).add(1, 'day').startOf('day')
      ].find(time => time.valueOf() > now.getTime())
      this.samplingTimer = setTimeout(() => this.refreshSamplingClock(), next.valueOf() - now.getTime())
    },
    // 沿用个人资料的高校、院系、校区字典；两类下级选项均按高校ID查询。
    async loadSamplingSchoolOptions(schoolId) {
      this.departOptions = []
      this.campusOptions = []
      if(!schoolId) return
      try {
        const [departRes, campusRes] = await Promise.all([
          schoolList({type: 2, parentId: schoolId}),
          schoolList({type: 3, parentId: schoolId})
        ])
        // 快速切换高校时，忽略上一次高校尚未完成的响应。
        if(this.form.homeSamplingAddressId != schoolId) return
        this.departOptions = departRes.data
        this.campusOptions = campusRes.data
      } catch(error) {
        // 请求错误由拦截器提示，保留空列表以便重新选择高校。
      }
    },
    changeSamplingSchool(value) {
      this.form.homeSamplingAddress = this.schoolOptions.find(item => item.schoolId == value).schoolName
      this.form.homeSamplingFaculty = ''
      this.form.homeSamplingFacultyId = null
      this.form.homeSamplingCampus = ''
      this.form.homeSamplingCampusId = null
      if(this.$refs.form2) this.$refs.form2.clearValidate(['homeSamplingFacultyId', 'homeSamplingCampusId'])
    },
    changeSamplingFaculty(value) {
      this.form.homeSamplingFaculty = this.departOptions.find(item => item.schoolId == value).schoolName
      this.form.homeSamplingCampus = ''
      this.form.homeSamplingCampusId = null
    },
    changeSamplingCampus(value) {
      this.form.homeSamplingCampus = this.campusOptions.find(item => item.schoolId == value).schoolName
    },
    getOther(){
      getUserOtherInfo(this.userInfo.clientId).then(res => {
        if(res.data){
          this.userOtherInfo = res.data
        }
      })
    },
    getOption () {
      unitList({type: 1}).then(res=> {
        this.unitList = res.data.filter(item => item.unitId == this.userInfo.unitId)
        this.activeAddress = 0
        if (res.data.length > 0) {
          this.addressInfo = this.unitList[this.activeAddress]
          this.form.addressId = this.unitList[this.activeAddress].unitId
        }
      })
      clientOrderList({clientId: this.userInfo.clientId}).then(res=> {
        if(res.rows && res.rows.length > 0){
          res.rows.map(item => {
            item.label = item.orderCode + '(' + item.equipmentName + ')'
          })
        }
        this.orderOptions = res.rows
      })
      listClientWhiteList({pageSize: 999, type: 2}).then(res=> {
        this.schoolOptions = res.rows
      })
    },
    handleClick() {
      this.activeAddress = 0
      if (this.unitList.length > 0) {
        this.addressInfo = this.unitList[0]
      }
      if(this.form.postMethod != 2){
        this.form.homeSamplingAddress = ''
        this.form.homeSamplingAddressId = null
        this.form.homeSamplingFaculty = ''
        this.form.homeSamplingFacultyId = null
        this.form.homeSamplingCampus = ''
        this.form.homeSamplingCampusId = null
        this.departOptions = []
        this.campusOptions = []
        this.form.detailedAddress = ''
        this.form.samplingContact = ''
        this.form.samplingContactPhone = ''
        this.form.onSiteSamplingDate = ''
        this.form.onSiteSamplingRemark = ''
      }else{
        if(this.userOtherInfo){
          this.form.homeSamplingAddress = this.userOtherInfo.lastHomeSamplingAddress
          this.form.homeSamplingAddressId = this.userOtherInfo.lastHomeSamplingAddressId
          this.form.homeSamplingFaculty = this.userOtherInfo.lastHomeSamplingFaculty
          this.form.homeSamplingFacultyId = this.userOtherInfo.lastHomeSamplingFacultyId
          this.form.homeSamplingCampus = this.userOtherInfo.lastHomeSamplingCampus
          this.form.homeSamplingCampusId = this.userOtherInfo.lastHomeSamplingCampusId
          this.form.detailedAddress = this.userOtherInfo.lastDetailedAddress
          this.form.samplingContact = this.userOtherInfo.lastSamplingContact
          this.form.samplingContactPhone = this.userOtherInfo.lastSamplingContactPhone
          this.form.onSiteSamplingRemark = this.userOtherInfo.lastOnSiteSamplingRemark
          this.form.onSiteSamplingDate = dayjs().format('YYYY-MM-DD')
          this.form.onSiteSamplingTime = this.userOtherInfo.lastOnSiteSamplingTime
        }
      }
    },
    selectRecycle(val) {
      if (val == 1) {
        this.form.provinceCode = this.userInfo.provinceCode;
        this.form.provinceValue = this.userInfo.provinceCode.split(",");
        this.form.recycleProvince = this.getCodeToText(this.form.provinceValue);
        this.form.recycleAddress = this.userInfo.address
        this.form.recycleContact = this.userInfo.clientName
        this.form.recycleContactPhone = this.userInfo.phoneNumber
      } else {
        this.form.provinceCode = "";
        this.form.recycleProvince = ""
        this.form.recycleAddress = ""
        this.form.recycleContact = ""
        this.form.recycleContactPhone = ""
      }
     },
    handleChange(value) {
      this.form.provinceValue = value;
      this.form.provinceCode = value.toString();
      this.form.recycleProvince = this.getCodeToText(value);
    },
    //把区域码转成汉字
    getCodeToText(value) {
      var name = "";
      value.map(item => (name += codeToText[item] + "/"));
      return name;
    },
    addressHandle(item, index) {
      this.form.addressId = item.unitId
      this.activeAddress = index;
      this.addressInfo = item;
    },
    freightHandle(item) {
      this.form.postPayment = item.index;
    },
    backInfo() {
      if(this.form.postMethod == 2) {
        this.$refs.form2.validate(valid=>{
          if(valid) {
            this.$refs.form.validate(valid_=>{
              this.$emit('getMailInfo',this.form,valid_)
            })
          }else {
            this.$emit('getMailInfo',this.form,valid)
          }
        })
        return
      }
      this.$refs.form.validate(valid=>{
        this.$emit('getMailInfo',this.form,valid)
      })
    }
  }
};
</script>
<style>
#mailOther .el-tag {
  padding: 0 30px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  margin: 20px 20px 0 20px;
  cursor: pointer;
}
#mailTop .el-tag {
  padding: 0 40px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  cursor: pointer;
  margin-right: 30px;
}
</style>
<style scoped>
.addressInfo {
  background: #edf0ff;
  border-radius: 7px;
  border: 1px dashed #4d6fff;
  width: 90%;
  margin: 20px 0 20px 20px;
  line-height: 30px;
  font-size: 14px;
  padding: 20px;
}
.jtaddress {
  color: #666666;
}
.addressOther {
  font-weight: 500;
  color: #111111;
}
.h3Title {
  margin-left: 20px;
}
.desc {
  margin-left: 15px;
  color: #f0a74a;
}
</style>
